import * as React from "react"
import { Component } from "react"
import { Button } from "semantic-ui-react"
import * as uuid from "uuid"
import { withTranslation } from "react-i18next"

export class FileUploadButton extends Component {
  constructor(props) {
    super(props)
    this.id = uuid.v1()
  }

  openFile = () => {
    document.getElementById(this.id).click()
  }

  render() {
    const { t } = this.props
    return (
      <>
        <div className="upload-file">
          <a className="link" htmlFor={this.id} onClick={this.openFile}>
            {this.props.content}
          </a>
          <p>{t("csvFileOnly")}</p>
          <input hidden id={this.id} type="file" onChange={this.props.onChangeFile} />
        </div>
      </>
    )
  }
}

export default withTranslation("vehicle")(FileUploadButton)
